/**
 * tag renderer cell component
 *
 * Custom cell for ag-grid that shows a tag.
 */
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { get } from 'lodash';

@Component({
  selector: 'xvi-tag-renderer',
  templateUrl: 'tag-renderer.component.html',
  styleUrls: ['tag-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XVITagRendererComponent implements AgRendererComponent {
  public params: ICellRendererParams;
  public fontColor: string;
  public bgColor: string;
  public tagName: string;

  public constructor() {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public refresh(params: any): boolean {
    return false;
  }

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    const metadata = get(params, 'data.metadata', []);
    const tagMetaData = metadata.find((item) => item.metadata_type === 'tag');
    this.fontColor = get(tagMetaData, 'text_color');
    this.bgColor = get(tagMetaData, 'background_color');
    this.tagName = get(tagMetaData, 'name');
  }
}
